import { render } from "./KmitlOneView.vue?vue&type=template&id=f0f01062&scoped=true"
import script from "./KmitlOneView.vue?vue&type=script&lang=js"
export * from "./KmitlOneView.vue?vue&type=script&lang=js"

import "./KmitlOneView.vue?vue&type=style&index=0&id=f0f01062&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0f01062"]])

export default __exports__